export const setIsRequiredAction = (state, action) => {
  state.questionList.forEach((question) => {
    if (question.id === action.payload.id) {
      question.required = action.payload.isRequired;
    }
  });
  state.hasUnsavedChanges = true;
};
